import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type SpotOrders = Record<string, SpotOrder> | null;

export interface SpotOrder {
  orderId: string;
  symbol: string;
  side: 'Buy' | 'Sell';
  qty?: string;
  amount?: string;
  leavesAmount: string;
  triggerPrice: string;
  triggerDirection: 'Up' | 'Down';
  // 25q4-limit-order feature flag
  orderType?: string;
  priceMatchStrategy?: string;
  price?: string;
  leavesQty?: string;
}

export interface SpotPendingPosition extends SpotOrder {
  orderVolumeType: 'qty' | 'amount';
  qty: string; // precision tradeQtyPrecision
  amount: string;
}

export const spotOrdersAtom = atom<SpotOrders>(null);

export const subscribeSpotOrdersBunja = createTableAccumulatorBunja(
  'private/spot-orders',
  (store) => (wsData) => store.set(spotOrdersAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
subscribeSpotOrdersBunja.debugLabel = 'subscribeSpotOrdersBunja';
